import qrcode from "qrcode-generator";

// Self-contained SVG QR — no external service, no network call at render
// time (qrcode-generator is bundled). Rendered as plain <rect> cells rather
// than dangerouslySetInnerHTML so it stays a normal React tree.
export default function QrCode({ value, size = 280 }: { value: string; size?: number }) {
  const qr = qrcode(0, "M");
  qr.addData(value);
  qr.make();
  const count = qr.getModuleCount();
  const cell = size / count;
  const cells: React.ReactElement[] = [];
  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (qr.isDark(row, col)) {
        cells.push(<rect key={`${row}-${col}`} x={col * cell} y={row * cell} width={cell} height={cell} />);
      }
    }
  }
  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
      role="img"
      aria-label="Código QR para participar en AIM 2026"
      style={{ background: "#fff", borderRadius: 12 }}
    >
      {cells}
    </svg>
  );
}
